<template>
  <div class="chip-status">
    <v-chip
      :color="payload.color"
      :text-color="payload.textColor"
      class="chip__width text-uppercase"
      :class="[addClass]"
      small
    >
      {{ payload.label }}
      <v-tooltip top v-if="reason">
        <template v-slot:activator="{ on, attrs }">
          <v-icon small v-bind="attrs" v-on="on" class="mb-0 ml-1">mdi-information-outline</v-icon>
        </template>
        <span v-html="reason"></span>
      </v-tooltip> 
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'ChipComponent',
  props: {
    addClass: {
      type: Array,
      default() {
        return []
      }
    },
    reason:{
      default:null
    },
    payload: {
      type: Object,
      required: true,
      default() {
        return {
          color: '',
          textColor: '',
          label: '',
        }
      },
    },
  },
}
</script>
<style scoped>
  .chip__width {
    min-width: 60px;
    justify-content: center;
  }
</style>
